import React from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'

const LoanSummaryModal = ({ show, onClose, summary }) => {
    if (!summary) {
        return null
    }

    const formatCurrency = (amount) => {
        const value = Number(amount) || 0
        try {
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' })
        } catch (_) {
            return `₹${value.toFixed(2)}`
        }
    }

    return (
        <Modal show={show} onHide={onClose} centered backdrop="static">
            <ModalHeader closeButton>
                <ModalTitle>Loan Summary</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className="table-responsive">
                    <table className="table table-sm mb-0">
                        <tbody>
                            <tr>
                                <td>Vehicle Cost</td>
                                <td className="text-end">{formatCurrency(summary.vehicleCost)}</td>
                            </tr>
                            <tr>
                                <td>Down Payment</td>
                                <td className="text-end">{formatCurrency(summary.downPayment)}</td>
                            </tr>
                            <tr>
                                <td>Processing Fees</td>
                                <td className="text-end">{formatCurrency(summary.processingFees)}</td>
                            </tr>
                            <tr>
                                <td>Loan Amount (incl. fees)</td>
                                <td className="text-end">{formatCurrency(summary.loanAmount)}</td>
                            </tr>
                            <tr>
                                <td>Interest Rate (annual)</td>
                                <td className="text-end">{summary.interestRate || 0}%</td>
                            </tr>
                            <tr>
                                <td>Tenure (months)</td>
                                <td className="text-end">{summary.tenureMonths}</td>
                            </tr>
                            <tr>
                                <td>EMI / month</td>
                                <td className="text-end fw-semibold">{formatCurrency(summary.monthlyEmi)}</td>
                            </tr>
                            <tr>
                                <td>Total Payable</td>
                                <td className="text-end">{formatCurrency(summary.totalPayable)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-primary" onClick={onClose}>
                    Close
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default LoanSummaryModal
